<template>
    <CustomerUser/>
</template>
<script>
import CustomerUser from 'operations/customer/customerUser.vue'
export default {
    components:{
        CustomerUser
    }
}
</script>